import { render, staticRenderFns } from "./PerformanceCoinsReports.vue?vue&type=template&id=cbf0e114&scoped=true&"
import script from "./PerformanceCoinsReports.vue?vue&type=script&lang=ts&"
export * from "./PerformanceCoinsReports.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceCoinsReports.vue?vue&type=style&index=0&id=cbf0e114&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf0e114",
  null
  
)

export default component.exports